import React from 'react';
import { HighlightCircle } from '../icons/HighlightCircle';
// Component for each product side button
const ProductSideButton = ({ side, displaySide, buttonText, icon, iconSelected, currentSide, customClass }) => {
    const checkCurrent = currentSide === side;
    const selectedIcon = React.createElement("img", { src: iconSelected, alt: `${buttonText} selected icon` });
    const unselectedIcon = React.createElement("img", { src: icon, alt: `${buttonText} icon` });
    return (React.createElement("button", { className: `hg-modal__product-side${checkCurrent ? ' active' : ''} ${customClass}`, onClick: () => displaySide(side), type: "button" },
        checkCurrent ? selectedIcon : unselectedIcon,
        React.createElement("span", { className: 'hg-modal__product-side--side-name' }, buttonText),
        React.createElement(HighlightCircle, null)));
};
export default ProductSideButton;
